import { createSelector } from 'reselect';
import { getMerchant } from './common';

export const getStakeholders = createSelector(getMerchant, ({ stakeholders = [] }) => stakeholders);

export const getStakeholdersByType = type =>
  createSelector(getStakeholders, stakeholders =>
    stakeholders ? stakeholders.filter(stakeholder => stakeholder.type === type) : [],
  );

export const getStakeholdersByRoles = roles =>
  createSelector(getStakeholders, stakeholders =>
    stakeholders
      ? stakeholders.filter(stakeholder => stakeholder.roles.some(role => roles.includes(role)))
      : [],
  );

export const getStakeholdersByRole = role => getStakeholdersByRoles([role]);

export const hasAnyStakeholderWithRoles = roles =>
  createSelector(
    getStakeholders,
    stakeholders =>
      stakeholders &&
      stakeholders.some(stakeholder => stakeholder.roles.some(role => roles.includes(role))),
  );
